module.exports = __webpack_public_path__ + "img/bell.8dc262f1.png";